import angular from 'angular';
import generalBusinessReviewDetailsComponent from './general-business-review-details.component';

let generalBusinessReviewDetailsModule = angular.module('generalBusinessReviewDetails', [])
  .component('generalBusinessReviewDetails', generalBusinessReviewDetailsComponent);

export default generalBusinessReviewDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/general-business-review-details/general-business-review-details.js